import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exitStudentView, storedStudentView } from "../utils/studentView";

export default function StudentViewBanner() {
  const location = useLocation();
  const navigate = useNavigate();
  const view = storedStudentView();
  const [exiting, setExiting] = useState(false);
  useEffect(() => {
    if (!view) return undefined;
    const sid = encodeURIComponent(view.student_id);
    if (!location.pathname.startsWith(`/student/${sid}/`) &&
        !location.pathname.startsWith(`/student/dashboard/${sid}/`) &&
        location.pathname !== `/student/dashboard/${sid}` && location.pathname !== `/student/${sid}`) {
      navigate(`/student/dashboard/${sid}/lessons`, { replace: true });
    }
    const previous = document.body.style.paddingTop;
    document.body.style.paddingTop = "72px";
    document.body.classList.add("student-view-active");
    return () => {
      document.body.style.paddingTop = previous;
      document.body.classList.remove("student-view-active");
    };
  }, [view, location.pathname, navigate]);

  // Existing forms are displayed, but editing/submission controls are disabled.
  // Backend enforcement and the transport guard also stop automatic mutations.
  useEffect(() => {
    if (!view) return undefined;
    const protect = () => {
      document.querySelectorAll("textarea, input:not([type=search]), select, [contenteditable=true]").forEach((node) => {
        if (node.tagName === "SELECT" || ["checkbox", "radio", "file", "range", "color"].includes(node.type)) {
          if (!node.disabled) node.disabled = true;
        }
        else if (node.hasAttribute("contenteditable")) node.setAttribute("contenteditable", "false");
        else if (!node.readOnly) node.readOnly = true;
      });
      document.querySelectorAll("button").forEach((node) => {
        const label = node.textContent.trim();
        if ((node.type === "submit" && node.closest("form")) || /^(submit|save|send|reset|generate|mark .*complete|begin video|get feedback|evaluate|acknowledge)/i.test(label)) {
          if (!node.disabled) node.disabled = true;
          node.title = "Read-only student view";
        }
      });
    };
    protect();
    const observer = new MutationObserver(protect);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["disabled", "readonly"] });
    return () => observer.disconnect();
  }, [view, location.pathname]);

  if (!view) return null;
  async function exit() {
    setExiting(true);
    let returnTo = view.returnTo || "/admin/users";
    try { returnTo = await exitStudentView(); }
    catch { /* Server restart/expiry must never trap the Admin in the view. */ }
    navigate(returnTo, { replace: true });
    setExiting(false);
  }
  return <div role="status" aria-label="Read-only student view" style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 10000, minHeight: 56, padding: "8px 20px", background: "#18354b", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
    <span>Viewing as <strong>{view.name}</strong> ({view.student_id}) · Read-only{view.expires_at * 1000 <= Date.now() ? " · Expired—open a new view" : ""}</span>
    <button type="button" onClick={exit} disabled={exiting}>{exiting ? "Exiting…" : "Exit Student View"}</button>
  </div>;
}
